import Vue from 'vue'
import startOfDay from 'date-fns/startOfDay'
import faqApi from '@/api/faq.api'
import faqService from '@/service/faq.service'

const module = {
  namespaced: true,

  state: {
    faqThemes: [],
    countNouveaute: 0,
    themeHasAtLeastOneNouveaute: {}
  },

  getters: {
    faqThemes (state) {
      return state.faqThemes
    },
    countNouveaute (state) {
      return state.countNouveaute
    },
    themeHasAtLeastOneNouveaute (state) {
      return state.themeHasAtLeastOneNouveaute
    }
  },
  mutations: {
    UPDATE_FAQ_THEME (state, faqThemes) {
      state.faqThemes = faqThemes
    },
    UPDATE_COUNT_NOUVEAUTE (state, value) {
      state.countNouveaute = value
    },
    UPDATE_HAS_AT_LEAST_ONE_NOUVEAUTE (state, value) {
      state.themeHasAtLeastOneNouveaute = value
    }
  },
  actions: {
    getFaqThemes ({ commit, dispatch }) {
      return faqApi.getFaqThemes()
        .then(result => {
          commit('UPDATE_FAQ_THEME', result)
          dispatch('refreshCountNouveaute')
          return result
        })
    },

    readQuestion ({ dispatch }, question) {
      Vue.$cookies.set('FAQ_QUESTION_DEJA_VU_' + question.id, 1, startOfDay(new Date(question.dateFinNouveaute)))
      dispatch('refreshCountNouveaute')
    },

    refreshCountNouveaute ({ commit, state }) {
      commit('UPDATE_COUNT_NOUVEAUTE', faqService.countThemeAvecNouveaute(state.faqThemes))
    },

    getHasAtLeastOneNouveaute ({ commit }, theme) {
      const object = {
        idTheme: theme.id,
        isThemeHaveAtLeastOneNouveaute: faqService.hasAtLeastOneNouveaute(theme)
      }
      commit('UPDATE_HAS_AT_LEAST_ONE_NOUVEAUTE', object)
    },
    updateFaqTheme ({ dispatch }, faqThemeASauvegarder) {
      let promiseUpdate
      if (faqThemeASauvegarder.id) {
        promiseUpdate = faqApi.updateFaqTheme(faqThemeASauvegarder.id, faqThemeASauvegarder)
      } else {
        promiseUpdate = faqApi.createFaqTheme(faqThemeASauvegarder)
      }
      return promiseUpdate.then(() => dispatch('getFaqThemes'))
    },
    deleteFaqTheme ({ dispatch }, faqThemeASupprimer) {
      return faqApi.deleteFaqTheme(faqThemeASupprimer.id)
        .then(() => dispatch('getFaqThemes'))
    },
    updateFaqQuestionReponse ({ dispatch }, faqQuestionReponseASauvegarder) {
      let promiseUpdate
      if (faqQuestionReponseASauvegarder.id) {
        promiseUpdate = faqApi.updateFaqQuestionReponse(faqQuestionReponseASauvegarder.id, faqQuestionReponseASauvegarder)
      } else {
        promiseUpdate = faqApi.createFaqQuestionReponse(faqQuestionReponseASauvegarder)
      }
      return promiseUpdate.then(() => dispatch('getFaqThemes'))
    },
    deleteFaqQuestionReponse ({ dispatch }, faqQuestionReponseASupprimer) {
      return faqApi.deleteFaqQuestionReponse(faqQuestionReponseASupprimer.id)
        .then(() => dispatch('getFaqThemes'))
    }

  }
}

export default module

